import { irScenesSlice } from "./irScenesSlice";
import * as actions from "./irScenesActions";
import * as selectors from "./irScenesSelectors";

export { actions };
export { selectors };
export default irScenesSlice.reducer;
